import { render } from "./EditFeatures.vue?vue&type=template&id=90b0bc3a&scoped=true"
import script from "./EditFeatures.vue?vue&type=script&lang=js"
export * from "./EditFeatures.vue?vue&type=script&lang=js"

import "./EditFeatures.vue?vue&type=style&index=0&id=90b0bc3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90b0bc3a"]])

export default __exports__